import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_legally_required_compensation_benefits_i'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_legally_required_compensation_benefits_i',
  name: 'Which of the following legally required compensation/ benefits is not directly paid to workers? (SELECT all that apply with an "X")',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'COMPULSORY_GROUP_INSURANCE_FOR_WORKERS',
      text: 'Compulsory group insurance for workers',
      externalIds: [
        {
          id: 'wb-wag-113x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMPENSATION_FOR_WORK_RELATED_ACCIDENTS_AND_DISEASES',
      text: 'Compensation for work-related accidents and diseases',
      externalIds: [
        {
          id: 'wb-wag-114x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMPENSATION_FOR_WORKER_S_DEATH',
      text: "Compensation for worker's death",
      externalIds: [
        {
          id: 'wb-wag-115x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'wb-wag-117x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wb-wag-118f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'COMPULSORY_GROUP_INSURANCE_FOR_WORKERS',
                'COMPENSATION_FOR_WORK_RELATED_ACCIDENTS_AND_DISEASES',
                'COMPENSATION_FOR_WORKER_S_DEATH',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-112',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9270,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
